var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckBallError = function SvgCheckBallError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F65050",
    fillRule: "evenodd",
    d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm2.471 3.529a.667.667 0 0 0-.942 0L8 7.057 6.471 5.53a.667.667 0 1 0-.942.942L7.057 8 5.53 9.529a.667.667 0 1 0 .942.942L8 8.943l1.529 1.528a.667.667 0 1 0 .942-.942L8.943 8l1.528-1.529a.667.667 0 0 0 0-.942Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckBallError;